// utils/limpiarDatosTienda.js — F6-finanzas (aislamiento por tienda, lado frontend).
//
// BUG que cierra: al cerrar sesión como un usuario (p. ej. una tienda Shopify) y entrar como otro
// (p. ej. Shopping Hunters) EN LA MISMA PESTAÑA, el catálogo seguía mostrando los productos del
// usuario anterior hasta un Ctrl+F5. El backend devuelve bien los datos de cada tienda; lo que no
// se limpiaba era el estado del FRONTEND (datos de tienda en memoria y en localStorage).
//
// Estrategia (robusta, imposible olvidar una caché): al login y al logout se BORRAN las claves
// PERSISTENTES de localStorage con datos de tienda y se RECARGA la página — la recarga vacía TODO
// el estado en memoria de React (productos, config, notificaciones, cachés de módulo) y re-lee del
// backend. Este helper borra lo persistente (lo que sobrevive a la recarga); la recarga la dispara
// quien llama (App.handleLogout / LoginPage.onLogin).
//
// CLAVES: datos de TIENDA que no deben cruzar un cambio de usuario. NO se listan las preferencias de
// UI puras (viewMode, sidebar, pantalla de analítica) — no son datos de tienda y molesta perderlas.
// Al agregar una clave de localStorage/sessionStorage con datos de tienda, AGREGARLA acá.
export const CLAVES_DATOS_TIENDA = [
  'label_short_names', // nombres cortos de etiquetas por producto/variación (datos de catálogo)
  'catalog_labeled',   // productos marcados como etiquetados (bitfield del catálogo)
];

export function limpiarDatosDeTienda(storage) {
  const ls = storage || (typeof window !== 'undefined' ? window.localStorage : null);
  if (!ls) return;
  for (const clave of CLAVES_DATOS_TIENDA) {
    try { ls.removeItem(clave); } catch (_) { /* storage no disponible: nada que limpiar */ }
  }
}
